import { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

import { faClockRotateLeft, faHome } from '@fortawesome/pro-light-svg-icons'

import { pathWithRedirect } from '@domain-group/javascript-utils'

import { Box, Button } from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import type { CampaignModel } from '@models/types'
import useCampaign from '@hooks/useCampaign'

interface PageLayoutProps {
  activeTabBarItemKey: 'dashboard',
  campaign: CampaignModel,
  children: ReactNode,
}

const PageLayout = (props: PageLayoutProps) => {
  const { activeTabBarItemKey, campaign, children } = props

  const { callbacks: { addCampaignItem }, campaign: { address } } = useCampaign(campaign)

  return (
    <>
      <Helmet>
        <title>{address || 'Campaign'} | Overview</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey={activeTabBarItemKey}
        actionContent={(
          <Button
            buttonStyle="primaryCreate"
            onClick={() => addCampaignItem()}
            size="medium"
            width="auto"
          >
            Create
          </Button>
        )}
        nestedNavigation
        showBackButton
        tabBarItems={[
          // @ts-expect-error TS2741
          {
            icon: faHome,
            key: 'dashboard',
            title: 'Dashboard',
          },
          {
            href: pathWithRedirect(`#/campaigns/${campaign.id}/edit/activity`),
            icon: faClockRotateLeft,
            key: 'activity',
            title: 'Activity',
          },
        ]}
        title="Overview"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        {children}
      </Box>
    </>
  )
}

export default PageLayout
